import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SortDirection } from "../models/Enum";
import { SelectedFilters } from "../models/Items/ItemListRequest";
import { NotificationLogRequest } from '../models/NotificationLogDetail';

type FiltersState = {
  selectedFilterOptions: any;
  selectedFilterValues: SelectedFilters;
}

interface NotificationLogState {
    notificationLogRequest: NotificationLogRequest;
    notificationLogFilter: FiltersState;
    isUserCleared: boolean;
};

export const initialNotificationLogRequest = {
    pageIndex: 1,
    pageSize: 10,
    sortBy: "id",
    sortDirection: SortDirection.DESC,
};

const initialState: NotificationLogState = {
    notificationLogRequest: initialNotificationLogRequest,
    notificationLogFilter: {
      selectedFilterOptions: {},
      selectedFilterValues: {},
    },
    isUserCleared: false,
};

const notificationLogs = createSlice({
    name: 'notificationLogs',
    initialState,
    reducers: {
      updateNotificationLogRequest(state, action: PayloadAction<NotificationLogRequest>) {
        state.notificationLogRequest = action.payload;
      },
      updateNotificationLogViewSelectedFilterOptions(state, action: PayloadAction<any>) {
        state.notificationLogFilter.selectedFilterOptions = action.payload;
      },
      updateNotificationLogViewSelectedFilterValues(state, action: PayloadAction<SelectedFilters>) {
        state.notificationLogFilter.selectedFilterValues = action.payload;
      },
      updateIsUserCleared(state, action: PayloadAction<boolean>) {
        state.isUserCleared = action.payload;
      },
    },
  });
  
  export const { updateNotificationLogRequest, updateNotificationLogViewSelectedFilterOptions, updateNotificationLogViewSelectedFilterValues, updateIsUserCleared } = notificationLogs.actions;
  
  export default notificationLogs.reducer;